import { Button } from '@/components/ui/button';
import { ChevronDown } from 'lucide-react';

interface FriendsButtonProps {
  onClick: () => void;
  isOpen?: boolean;
}

export function FriendsButton({ onClick, isOpen }: FriendsButtonProps) {
  return (
    <Button
      onClick={onClick}
      variant="ghost"
      size="sm"
      className="h-8 px-3 text-sm text-arc-text-main hover:text-arc-primary hover:bg-arc-panel flex items-center gap-2"
    >
      <div className="w-2 h-2 rounded-full bg-green-500" />
      <span>Social</span>
      <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
    </Button>
  );
}

